import axios from '@/libs/api.request'

export const login = (data) => {
  return axios.request({
    url: '/enterprise/login/auth/',
    data,
    method: 'post'
    // headers:{
    //   'Content-Type':'application/x-www-form-urlencoded'
    // }
  })
}

export const loginCode = (data) => {
  return axios.request({
    url: '/enterprise/login/mobileauth/',
    data,
    method: 'post'
  })
}

// 注册
export const enterpriseRegister = (data) => {
  return axios.request({
    url: '/enterprise/register/',
    data,
    method: 'post'
  })
}

// 注册发送验证码
export const smssend = (data) => {
  return axios.request({
    url: '/sms/smssend/',
    data,
    method: 'post'
  })
}

//
// export const getUserInfo = (token) => {  //测试 模拟
//   return axios.request({
//     url: 'https://www.easy-mock.com/mock/5add9213ce4d0e69998a6f51/iview-admin/get_info',
//     params: {
//       token
//     },
//     method: 'get'
//   })
// }

export const getuserpermission = (data) => {  //获取管理员所有权限--企业端登录请求【王龙】
  return axios.request({
    url: '/permission/getuserpermission',
    params:data,
    method: 'get'
  })
}
// 权限列表--没有上下级关系【王龙】
export const getermissionlist = (data) => {
  return axios.request({
    url: '/permission/permissionlist',
    params:data,
    method: 'get'
  })
}

// 权限列表--没有上下级关系【王龙】
export const getpermissionrelationlist = (data) => {
  return axios.request({
    url: '/permission/permissionrelationlist',
    params:data,
    method: 'get'
  })
}

export const logout = (token) => {
  return axios.request({
    url: 'logout',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js